import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { hentStiEtterInnlogging } from '../lib/etterInnlogging'

// Microsoft-innloggingen og innloggingslenken kommer tilbake til forsiden.
// Startet innloggingen på en annen side (QR-koden fra en skjerm går til
// /skjermer/koble?kode=…), sendes brukeren dit når innloggingen er klar
// (src/lib/etterInnlogging.js). Bare på forsiden og bare når innloggingen er
// ny, så en vanlig navigering aldri blir avbrutt.
export function useStiEtterInnlogging(innlogget) {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  useEffect(() => {
    if (!innlogget || pathname !== '/') return
    const sti = hentStiEtterInnlogging()
    if (sti) navigate(sti, { replace: true })
    // Bare når innloggingen er ny, ikke ved hver navigering.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [innlogget])
}
